import PropTypes from 'prop-types';

export const SplitCSV = ({ text }) => {
	const splitAndMapWithBreak = () => {
		const values = text.split(','); // Split the string at commas to get an array of values
		const mappedArray = values.map((value, index) => {
			const trimmedValue = value.trim();
			return index === values.length - 1
				? trimmedValue
				: trimmedValue + ',';
		});

		return mappedArray;
	};

	const result = splitAndMapWithBreak(text);

	return (
		<>
			{result.map((item, index) => {
				return (
					<div key={index}>
						{item}
						<br />
					</div>
				);
			})}
		</>
	);
};

export const SplitCSVPropTypes = {
	text: PropTypes.string,
};
